import React from 'react';
import { Col, Table } from 'react-bootstrap';
import { TextData } from '../../../types/admin';
import { formatDate } from '../utils';

type Props = {
    optionsData: TextData;
};

export const OpenTable = ({ optionsData }: Props) => {
    const { labels, data } = optionsData;

    return (
        <Col xs={12}>
            <div className='admin-card'>
                <Table striped hover responsive>
                    <thead>
                        <tr>
                            {labels.map((label, index) => (
                                <th key={index}>{label}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((row, rowIndex) => (
                            <tr key={rowIndex}>
                                {row.map((cell: any, cellIndex: number) => {
                                    // Log cell data for debugging

                                    // Check if the cell is an array containing user_id and user_name
                                    if (Array.isArray(cell) && cell[0].length === 2) {
                                        return (
                                            <td key={cellIndex}>
                                                <a href={`/admin/sessions/${cell[0][0]}`}>{cell[0][1]}</a>
                                            </td>
                                        );
                                    }

                                    // Check if the cell is a date string
                                    if (typeof cell === 'string' && cell.includes('T')) {
                                        return <td key={cellIndex}>{formatDate(cell)}</td>;
                                    }

                                    // Default case: render the cell content or a placeholder if empty
                                    return <td key={cellIndex}>{cell || '-'}</td>;
                                })}
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
        </Col>
    );
};

export default OpenTable;